import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/vercel/path0/node_modules/.pnpm/@iconify+react@5.2.1_react@18.3.1/node_modules/@iconify/react/dist/iconify.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.57.0_react-dom@18_ixrbvmtvnipsi5ntc6vhm3s7wm/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/LoginAnimation/login-animation.css");
